import React, { memo } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { VenueSettingsApi } from "../../../../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<VenueSettingsApi>;
	language: string;
}

const TipSettingsLanguageInputs = memo(({ language, form }: Props) => {
	const { register, getValues } = form;
	const { t } = useTranslation();
	const translations = getValues("tip_settings.tip_header_translations");
	const index = translations.findIndex((translation) => translation.locale === language);

	if (index === -1) return null;

	return (
		<div className="row">
			<div className="col">
				<FormInput
					name={`tip_settings.tip_header_translations.${index}.locale`}
					errors={[]}
					register={register}
					type="hidden"
				/>
				<FormInput
					name={`tip_settings.tip_header_translations.${index}.header`}
					errors={[]}
					label={`${t("common.word.language")} ${t(`lib:enums.languages.${language}`).toLowerCase()}`}
					register={register}
				/>
			</div>
		</div>
	);
});

export default TipSettingsLanguageInputs;
